const mappingsTools = require('@/utils/mapTools')

const DATA_MAP = {
  operationType: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }, {
      label: '免费许可',
      value: '4'
    },
  ],
  auditStatus: [{
      label: '待审核',
      value: 0
    },
    {
      label: '审核通过',
      value: 1
    },
    {
      label: '审核不通过',
      value: 2
    }
  ],
  type: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }
  ],
  status: [{
      label: '已发布',
      value: '0'
    },
    {
      label: '未发布',
      value: '1'
    },
    {
      label: '未发布',
      value: '2'
    },
  ],
  useStatus: [{
      label: '启用',
      value: '0'
    },
    {
      label: '停用',
      value: '1'
    }
  ]
}
const v2Label = mappingsTools.key2Value(DATA_MAP) // 映射表数据处理

module.exports = {
  v2Label
}
